import { Icon } from '@chakra-ui/react';

const PCGoogleAdIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<g id="path12">
				<path class="st0" d="M10.02,26.86l-9.06-5.08l4.73-8.17c0.08-0.16,0.18-0.32,0.28-0.47l4.2-7.18c0.05-0.1,0.11-0.21,0.17-0.31
			c1.44-2.47,4.64-3.32,7.13-1.89c1.22,0.69,2.08,1.81,2.44,3.15c0.36,1.33,0.17,2.72-0.53,3.91c-0.06,0.11-0.13,0.21-0.19,0.3
			l-4.2,7.18c-0.08,0.16-0.18,0.32-0.28,0.48L10.02,26.86z M2.89,21.25l6.61,3.71l4.04-6.94c0.08-0.12,0.15-0.24,0.22-0.37
			l0.02-0.04l4.25-7.26c0.05-0.08,0.11-0.16,0.15-0.24l0,0c0.51-0.87,0.64-1.87,0.38-2.84c-0.26-0.98-0.89-1.79-1.78-2.3
			c-1.83-1.04-4.17-0.42-5.23,1.38c-0.04,0.08-0.09,0.16-0.13,0.25l-0.03,0.05l-4.24,7.25C7.07,14.02,7,14.15,6.93,14.28L6.92,14.3
			L2.89,21.25z"/>
			</g>
			<g id="path14">
				<path class="st1" d="M10.44,26.25c-1.45,2.53-4.71,3.46-7.21,2c-2.51-1.46-3.39-4.63-1.95-7.15s4.68-3.46,7.18-2
			C10.97,20.55,11.89,23.72,10.44,26.25"/>
			</g>
			<g id="path16">
				<path class="st2" d="M19.98,28.64c-0.88,0-1.76-0.22-2.58-0.69c-1.2-0.7-2.06-1.81-2.41-3.14c-0.36-1.33-0.17-2.72,0.52-3.91
			l4.47-7.73c1.43-2.46,4.6-3.31,7.06-1.89l0.01,0c2.47,1.43,3.31,4.59,1.89,7.05l-4.47,7.73C23.51,27.72,21.77,28.64,19.98,28.64z
			 M24.47,12c-1.3,0-2.57,0.67-3.27,1.88l-4.47,7.73c-0.5,0.87-0.64,1.88-0.38,2.85c0.26,0.97,0.88,1.78,1.75,2.28
			c1.81,1.04,4.12,0.43,5.16-1.37l4.47-7.73c1.04-1.79,0.42-4.09-1.37-5.13l0.34-0.61l-0.35,0.61C25.76,12.16,25.11,12,24.47,12z"/>
			</g>
		</g>

	</Icon>
);

export default PCGoogleAdIcon;
